import React from "react";
import { Modal } from "react-bootstrap";
import BftButton from "../button";

interface Props {
	show: boolean;
	onClose: () => void;
	message: any;
	title?: any;
	footerMessage?: string;
	className?: string;
	centered?: boolean;
}

const MessageModal: React.FC<Props> = (props) => {
	const { show, onClose, message, title, footerMessage, className, centered } = props;

	return (
		<Modal centered={centered ?? true} show={show} onHide={onClose} dialogClassName={className}>
			<Modal.Header closeButton>
				<Modal.Title>
					<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
						<i className="fas fa-exclamation-triangle" style={{ color: "#ff0000" }} />
						{title || "ATTENZIONE"}
					</div>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>{message}</Modal.Body>
			{footerMessage && (
				<Modal.Footer className="d-flex justify-content-around">
					<h5>{footerMessage}</h5>
					<BftButton className="btn-buffetti" onClick={onClose}>
						Ok
					</BftButton>
				</Modal.Footer>
			)}
		</Modal>
	);
};
// react bootstrap modal vertical align center
// https://stackoverflow.com/questions/56238356/center-modal-in-bootstrap-4
export default MessageModal;
